var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-vh-100"},[_c('div',{staticClass:"sales-channels"},[_c('div',{staticClass:"sales-channels__left"},[_c('Sidebar')],1),_c('div',{staticClass:"sales-channels__right"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }